import VSpeedDial from './VSpeedDial'

VSpeedDial.install = function install (Vue) {
  Vue.component(VSpeedDial.name, VSpeedDial)
}

export default VSpeedDial



// WEBPACK FOOTER //
// ./src/components/VSpeedDial/index.js